import React, { Component, useState } from "react";
import PlacesAutocomplete from "react-places-autocomplete";
import {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng,
} from "react-places-autocomplete";

const GoogleAutocomplete = (props) => {
  const {
    address,
    lat,
    lng,
    onChange,
    label,
    className,
    margin,
    type,
    errors,
    helperText,
    name,
  } = props;
  const handleChange = (address) => {
    if (address == "") {
      onChange({ address: address, lat: 0, lng: 0 });
    } else {
      onChange({ address: address, lat: lat, lng: lng });
    }
  };
  const getAddressComponent = (components, types) =>
    components?.find((component) =>
      types.some((type) => component.types.includes(type))
    )?.long_name || "";

  const getPlaceName = (address, components) => {
    const firstAddressPart = address?.split(",")?.[0]?.trim() || "";
    const componentNames = components?.map((component) => component.long_name) || [];

    return componentNames.includes(firstAddressPart) ? "" : firstAddressPart;
  };

  const handleSelect = (address, placeId) => {
    geocodeByAddress(address)
      .then(async (results) => {
        console.log(results, "resimdlkakd");
        const latLng = await getLatLng(results[0]);
        return {
          latLng,
          addressP: results,
          placedId: placeId || results[0].place_id,
        };
      })
      .then(({ latLng, addressP, placedId }) => {
        const components = addressP?.[0]?.address_components || [];
        const data = {
          address: address,
          lat: latLng.lat,
          lng: latLng.lng,
          placedId,
          name: getPlaceName(address, components),
          city: getAddressComponent(components, [
            "locality",
            "postal_town",
            "administrative_area_level_2",
            "sublocality",
            "sublocality_level_1",
          ]),
          state: getAddressComponent(components, [
            "administrative_area_level_1",
          ]),
          country: getAddressComponent(components, ["country"]),
          postal_code: getAddressComponent(components, ["postal_code"]),
        };

        onChange({
          ...data,
        });
      })
      .catch((error) => {
        onChange({
          address: "NA",
          lat: 0,
          lng: 0,
        });
      });
  };

  return (
    <PlacesAutocomplete
      value={address}
      onSelect={handleSelect}
      onChange={handleChange}
      searchOptions={{
        componentRestrictions: { country: ["th", "vn"] },
      }}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps }) => (
        <div className="position-relative">
          <input
            label={label}
            type={type}
            fullWidth
            error={errors[name] && errors[name]?.length > 0 ? true : false}
            helperText={
              errors[name] && errors[name]?.length > 0
                ? errors[name]
                : helperText
            }
            className={className}
            margin={margin}
            {...getInputProps({
              placeholder: "Search Places ...",
              className: `form-control ${className}`,
            })}
          />
          <div className="autocomplete-dropdown-container  bg-white position-absolute "
          style={{top:"46px",overflowY:"auto", maxHeight:"200px", left: 0, right: 0, zIndex: 1000}}
          >
            {suggestions.map((suggestion) => {
              const className = suggestion.active
                ? "suggestion-item--active"
                : "suggestion-item";
              // inline style for demonstration purpose
              const style = suggestion.active
                ? { backgroundColor: "rgb(204 214 239)", cursor: "pointer" }
                : { backgroundColor: "#ffffff", cursor: "pointer" };
              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className,
                    style,
                  })}
                  
                >
                  <div className="google-select-pop p-2 border-bottom"
                
                  >
                    {suggestion.description}
                  </div>
                  {/* <span></span> */}
                  {/* <div className="border-bottom border-dark2"></div> */}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
};
GoogleAutocomplete.defaultProps = {
  type: "text",
  className: "input-text",
  label: "Text Input",
  margin: "normal",
  errors: {},
  helperText: "",
};
export default GoogleAutocomplete;
